import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getOidcConfigs} from "../../../actions/actionOidc"
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

class ViewOidcConfig extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentOidcConfig: {}
        }
    }
  
    componentDidMount(){
        this.props.getOidcConfigs();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.oidc_configs.length > 0){
            let currentOidcConfig = nextProps.oidc_configs.find(oidc_configs => oidc_configs.oidc_id === this.props.match.params.id);
            this.setState({currentOidcConfig: currentOidcConfig});
        }
    }

    render(){
        const {currentOidcConfig} = this.state;
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View OpenID Config</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                    <div className="profile-table">
                                            {currentOidcConfig ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Id</h4></td><td>{currentOidcConfig.oidc_id ? currentOidcConfig.oidc_id : "-"}</td></tr>
                                                        <tr><td><h4>Direct Login URL</h4></td><td>{currentOidcConfig.oidc_id ?
                                                            "https://" + window.location.host + "/api/sso_login?id=" + currentOidcConfig.oidc_id : "-"}</td></tr>
                                                        <tr><td><h4>Display Name</h4></td><td>{currentOidcConfig.display_name ? currentOidcConfig.display_name : "-"}</td></tr>
                                                        <tr><td><h4>Logo URL</h4></td><td>{currentOidcConfig.logo_url ? currentOidcConfig.logo_url : "-"}</td></tr>
                                                        <tr><td><h4>Enabled </h4></td><td><img src={currentOidcConfig.enabled ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Auto Login </h4></td><td><img src={currentOidcConfig.auto_login ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Hostname</h4></td><td>{currentOidcConfig.hostname ? currentOidcConfig.hostname : "-"}</td></tr>
                                                        <tr><td><h4>Default </h4></td><td><img src={currentOidcConfig.is_default ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Client ID</h4></td><td>{currentOidcConfig.client_id ? currentOidcConfig.client_id : "-"}</td></tr>
                                                        <tr><td><h4>Client Secret</h4></td><td>{currentOidcConfig.client_secret ? currentOidcConfig.client_secret : "-"}</td></tr>
                                                        <tr><td><h4>Authorization URL</h4></td><td>{currentOidcConfig.auth_url ? currentOidcConfig.auth_url : "-"}</td></tr>
                                                        <tr><td><h4>Token URL</h4></td><td>{currentOidcConfig.token_url ? currentOidcConfig.token_url : "-"}</td></tr>
                                                        <tr><td><h4>User Info URL</h4></td><td>{currentOidcConfig.user_info_url ? currentOidcConfig.user_info_url : "-"}</td></tr>

                                                        <tr><td><h4>Scope</h4></td><td>
                                                            { currentOidcConfig.scope ?
                                                                <ReactJson src={currentOidcConfig.scope}
                                                                           name={false}
                                                                           collapsed={false}
                                                                           sortKeys={true}
                                                                           collapseStringsAfterLength={40}
                                                                           enableClipboard={false}
                                                                           displayDataTypes={false}
                                                                />
                                                                : "-"
                                                            }
                                                        </td></tr>
                                                        <tr><td><h4>Username Attribute</h4></td><td>{currentOidcConfig.username_attribute ? currentOidcConfig.username_attribute : "-"}</td></tr>
                                                        <tr><td><h4>Groups Attribute</h4></td><td>{currentOidcConfig.groups_attribute ? currentOidcConfig.groups_attribute : "-"}</td></tr>
                                                        <tr><td><h4>Debug </h4></td><td><img src={currentOidcConfig.debug ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Redirect URL</h4></td><td>{currentOidcConfig.redirect_url ? currentOidcConfig.redirect_url : "-"}</td></tr>

                                                    </tbody>
                                                </Table> : " "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewOidcConfig.propTypes = {
    oidc_configs: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        oidc_configs: state.oidc.oidc_configs || [],
    }),
dispatch => 
    ({  
        getOidcConfigs: () => dispatch(getOidcConfigs()),
    }))(ViewOidcConfig);